export function createIdempotencyKey(): string {
  try {
    // Browser runtime
    if (typeof crypto !== 'undefined' && typeof (crypto as any).randomUUID === 'function') {
      return (crypto as any).randomUUID();
    }
  } catch {}
  // Fallback for older environments
  const rnd = Math.random().toString(36).slice(2);
  return `${Date.now().toString(36)}-${rnd}`;
}
